import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Icon } from '@safelyq/bulma-ui-library';
import { useProfile } from 'hooks/useProfile';
import { useSelector, useDispatch } from 'react-redux';
import { useUnsavedChanges } from 'contexts/UnsavedChangesContext';
import { setActiveItem, toggleSidebar } from 'Redux/MiscSlice/Misc';
import {
  MenuContainer,
  Header,
  AppInfo,
  LogoBox,
  AppDetails,
  AppName,
  AppRole,
  BusinessBadge,
  StatusDot,
  ScrollArea,
  MenuGroup,
  GroupTitle,
  MenuItem,
  StyledLink,
  DropdownTrigger,
  SubMenu,
  SubMenuItem,
  SubLink,
  Badge,
  CollapseButton
} from './StyledMenu';
import { Tooltip } from 'antd';

export const MenuList = ({ ...props }) => {
  const { businessId, handleMenuClose } = props;
  const dispatch = useDispatch();
  let { pathname } = useLocation();
  const { logout } = useProfile();
  const history = useHistory();
  const { guardNavigation } = useUnsavedChanges();
  const businessName = useSelector(state => state?.business?.businessName);
  const businessCategory = useSelector(state => state?.business?.businessCategory);
  const activeItem = useSelector(state => state?.misc?.activeItem)
  const isSidebarCollapsed = useSelector(state => state?.misc?.isSidebarCollapsed)
  const isAssociate = useSelector(state => state?.business?.isAssociate);
  const messageCountGlobal = useSelector((state) => state?.business?.messageCount);
  const activeCampaings = useSelector((state) => state?.misc?.activeCampaings);
  const unpaidOrders = useSelector((state) => state?.misc?.unpaidOrders);

  if (pathname?.charAt(pathname?.length - 1) === '/') {
    pathname = pathname?.slice(0, pathname?.length - 1);
  };

  const checkActive = (path) => {
    return pathname?.includes(path);
  };

  const isActiveLogs = checkActive('/admin/dashboard');
  const isActiveAppointments = checkActive('/admin/appointments');
  const isActiveNewAppointment = checkActive('/admin/create-appointment');
  const isActiveInventory = checkActive('/admin/inventory');
  const isActiveOrders = checkActive('/admin/orders');
  const isActiveForms = checkActive('/admin/forms');
  const isActiveExternalForms = checkActive('/admin/external_form');
  const isActiveNewForms = checkActive('/admin/create-form');
  const isActiveCreateExternalForms = checkActive('/admin/create_external_form');
  const isActiveReportSummary = checkActive('/admin/reports-summary');
  const isActiveManageHolidays = checkActive('/admin/manage-business');
  const isActiveManageConsole = checkActive('/admin/manage-console');
  const isActiveManageReserveWithGoogle = checkActive('/admin/reserve-with-google');
  const ispricing = checkActive('/admin/pricing');
  const isStripeAccount = checkActive('/admin/payment');
  const isActivePromotions = checkActive('/admin/coupons');
  const isActiveMessages = checkActive('/admin/messages');
  const isActiveViewCampaign = checkActive('/admin/view-campaign');
  const isActiveCreateCampaign = checkActive('/admin/create-campaign');
  const isActiveManageFiles = checkActive('/admin/manage-files');
  // const isActiveCampaignDeliveryDetails = checkActive('/admin/campaign-delivery-details');
  const isActiveReviews = checkActive('/admin/manage-reviews');
  const isActiveUsers = checkActive('/admin/manage-users');

  const handleToggle = (index) => {
    dispatch(setActiveItem(activeItem === index ? null : index));
  };

  const isDropdownActive = (index) => {
    return activeItem === index;
  };

  const handleLogout = () => {
    localStorage.setItem('post_logout_redirect_url', '/admin');
    localStorage.setItem("authPersist", "false") // change the logged in flag to false
    logout();
  };

  const handleSidebarToggle = (e) => {
    e.stopPropagation();
    dispatch(toggleSidebar());
  }

  return (
    <MenuContainer collapsed={isSidebarCollapsed}>
      <Header collapsed={isSidebarCollapsed}>
        <div className='is-flex is-justify-content-space-between align-items-center'>
          <AppInfo collapsed={isSidebarCollapsed}>
            <LogoBox className='is-clickable'
              onClick={(e) => {
                e.preventDefault(); // stops the hash jump / navigation
                handleMenuClose();
                guardNavigation(() => {
                  history.push(`/admin/dashboard/${businessId}`);
                });
              }}
              collapsed={isSidebarCollapsed}>
              <div className='navbar-brand' style={{ width: '100%' }}>
                <div className='chatslb-logo is-flex'>
                  <img id="chatclb_icon" src='/images/chatclb_logo.png' alt='logo' />
                </div>
              </div>
            </LogoBox>

            {!isSidebarCollapsed && (
              <AppDetails className='is-clickable'
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/dashboard/${businessId}`);
                  });
                }}>
                <AppName>
                  <img src='/images/logo_name.png' alt='ChatCLB Logo' />
                </AppName>
                <AppRole>Business Admin</AppRole>
              </AppDetails>
            )}
          </AppInfo>

          {!isSidebarCollapsed && <CollapseButton className='is-hidden-mobile' onClick={handleSidebarToggle} collapsed={isSidebarCollapsed}>
            <Icon name={isSidebarCollapsed ? 'angle-right' : 'angle-left'} />
          </CollapseButton>}
        </div>

        {isSidebarCollapsed && <CollapseButton onClick={handleSidebarToggle} collapsed={isSidebarCollapsed}>
          <Icon name={isSidebarCollapsed ? 'angle-right' : 'angle-left'} />
        </CollapseButton>}

        <BusinessBadge collapsed={isSidebarCollapsed}>
          <StatusDot />
          {businessName || 'Unknown'}
        </BusinessBadge>
      </Header>

      <ScrollArea collapsed={isSidebarCollapsed}>
        <MenuGroup collapsed={isSidebarCollapsed}>
          {!isSidebarCollapsed && <GroupTitle>Overview</GroupTitle>}
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Dashboard' : ''} placement="right">
              <StyledLink
                to="#"
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/dashboard/${businessId}`);
                  });
                }}
                active={isActiveLogs} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='columns' /></div>
                {!isSidebarCollapsed && 'Dashboard'}
              </StyledLink>
            </Tooltip>
          </MenuItem>
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Inbox' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/messages/${businessId}`);
                  });
                }}
                active={isActiveMessages} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='inbox' /></div>
                {!isSidebarCollapsed && 'Inbox'}
                {messageCountGlobal && !isSidebarCollapsed ? <Badge>{messageCountGlobal > 9 ? '9+' : messageCountGlobal}</Badge> : null}
              </StyledLink>
            </Tooltip>
          </MenuItem>
        </MenuGroup>

        <MenuGroup collapsed={isSidebarCollapsed}>
          {!isSidebarCollapsed && <GroupTitle>Bookings</GroupTitle>}
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Appointments / Reservations' : ''} placement="right">
              <DropdownTrigger onClick={() => handleToggle(1)} active={isActiveAppointments || isActiveNewAppointment || isActiveReportSummary} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='bell' /></div>
                {!isSidebarCollapsed && 'Appointments / Reservations'}
                <div className="arrow"><Icon name={isDropdownActive(1) ? 'angle-up' : 'angle-down'} /></div>
              </DropdownTrigger>
            </Tooltip>
            {isDropdownActive(1) && (
              <SubMenu collapsed={isSidebarCollapsed}>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'View List' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/appointments/${businessId}`);
                        });
                      }}
                      active={isActiveAppointments} collapsed={isSidebarCollapsed}>
                      <Icon name="list-ul" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'View List'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Create New' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/create-appointment/${businessId}`);
                        });
                      }}
                      active={isActiveNewAppointment} collapsed={isSidebarCollapsed}>
                      <Icon name="plus" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Create New'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Reports' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/reports-summary/${businessId}`);
                        });
                      }}
                      active={isActiveReportSummary} collapsed={isSidebarCollapsed}>
                      <Icon name="flag" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Reports'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
              </SubMenu>
            )}
          </MenuItem>
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Reviews' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/manage-reviews/${businessId}`);
                  });
                }}
                active={isActiveReviews} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='star' /></div>
                {!isSidebarCollapsed && 'Reviews'}
              </StyledLink>
            </Tooltip>
          </MenuItem>
        </MenuGroup>

        <MenuGroup collapsed={isSidebarCollapsed}>
          {!isSidebarCollapsed && <GroupTitle>Sales</GroupTitle>}
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Sales Set-Up' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/inventory/${businessId}`);
                  });
                }}
                active={isActiveInventory} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='file-text-o' /></div>
                {!isSidebarCollapsed && 'Sales Set-Up'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Orders' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/orders/${businessId}`);
                  });
                }}
                active={isActiveOrders} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='shopping-cart' /></div>
                {!isSidebarCollapsed && 'Orders'}
                {unpaidOrders && !isSidebarCollapsed ? <Badge>{unpaidOrders > 9 ? '9+' : unpaidOrders}</Badge> : null}
              </StyledLink>
            </Tooltip>
          </MenuItem>
        </MenuGroup>

        <MenuGroup collapsed={isSidebarCollapsed}>
          {!isSidebarCollapsed && <GroupTitle>Marketing</GroupTitle>}
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Campaigns' : ''} placement="right">
              <DropdownTrigger onClick={() => handleToggle(3)} active={isActiveViewCampaign || isActiveCreateCampaign || isActiveManageFiles} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='bullhorn' /></div>
                {!isSidebarCollapsed && 'Campaigns'}
                {activeCampaings && !isSidebarCollapsed ? <Badge>{activeCampaings > 9 ? '9+' : activeCampaings}</Badge> : null}
                <div className="arrow"><Icon name={isDropdownActive(3) ? 'angle-up' : 'angle-down'} /></div>
              </DropdownTrigger>
            </Tooltip>
            {isDropdownActive(3) && (
              <SubMenu collapsed={isSidebarCollapsed}>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'View List' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/view-campaign/${businessId}`);
                        });
                      }}
                      active={isActiveViewCampaign} collapsed={isSidebarCollapsed}>
                      <Icon name="list" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'View List'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Create New' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/create-campaign/${businessId}`);
                        });
                      }}
                      active={isActiveCreateCampaign} collapsed={isSidebarCollapsed}>
                      <Icon name="plus" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Create New'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Manage Files' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/manage-files/${businessId}`);
                        });
                      }}
                      active={isActiveManageFiles} collapsed={isSidebarCollapsed}>
                      <Icon name="folder-open" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Manage Files'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                {/* <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Campaign Delivery Details' : ''} placement="right">
                    <SubLink to={`/admin/campaign-delivery-details/${businessId}`} onClick={toggle} active={isActiveCampaignDeliveryDetails} collapsed={isSidebarCollapsed}>
                      <Icon name="truck" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Campaign Delivery Details'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem> */}
              </SubMenu>
            )}
          </MenuItem>
          {businessCategory?.features?.couponAllowed && (
            <MenuItem collapsed={isSidebarCollapsed}>
              <Tooltip title={isSidebarCollapsed ? 'Coupons / Promotions' : ''} placement="right">
                <StyledLink
                  to={`#`}
                  onClick={(e) => {
                    e.preventDefault(); // stops the hash jump / navigation
                    handleMenuClose();
                    guardNavigation(() => {
                      history.push(`/admin/coupons/${businessId}`);
                    });
                  }}
                  active={isActivePromotions} collapsed={isSidebarCollapsed}>
                  <div className="icon-wrap"><Icon name='tag' /></div>
                  {!isSidebarCollapsed && 'Coupons / Promotions'}
                </StyledLink>
              </Tooltip>
            </MenuItem>
          )}
        </MenuGroup>

        <MenuGroup collapsed={isSidebarCollapsed}>
          {!isSidebarCollapsed && <GroupTitle>Settings & Management</GroupTitle>}
          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Manage Business' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/manage-business/${businessId}`);
                  });
                }}
                active={isActiveManageHolidays} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='cog' /></div>
                {!isSidebarCollapsed && 'Manage Business'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Forms / Documents' : ''} placement="right">
              <DropdownTrigger onClick={() => handleToggle(2)} active={isActiveForms || isActiveNewForms || isActiveExternalForms || isActiveCreateExternalForms} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='file-text' /></div>
                {!isSidebarCollapsed && 'Forms / Documents'}
                <div className="arrow"><Icon name={isDropdownActive(2) ? 'angle-up' : 'angle-down'} /></div>
              </DropdownTrigger>
            </Tooltip>
            {isDropdownActive(2) && (
              <SubMenu collapsed={isSidebarCollapsed}>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Internal List' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/forms/${businessId}`);
                        });
                      }}
                      active={isActiveForms} collapsed={isSidebarCollapsed}>
                      <Icon name="list" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Internal List'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Create Internal' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/create-form/${businessId}`);
                        });
                      }}
                      active={isActiveNewForms} collapsed={isSidebarCollapsed}>
                      <Icon name="plus" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Create Internal'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'External List' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/external_form/${businessId}`);
                        });
                      }}
                      active={isActiveExternalForms} collapsed={isSidebarCollapsed}>
                      <Icon name="list" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'External List'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
                <SubMenuItem>
                  <Tooltip title={isSidebarCollapsed ? 'Link External' : ''} placement="right">
                    <SubLink
                      to={`#`}
                      onClick={(e) => {
                        e.preventDefault(); // stops the hash jump / navigation
                        handleMenuClose();
                        guardNavigation(() => {
                          history.push(`/admin/create_external_form/${businessId}`);
                        });
                      }}
                      active={isActiveCreateExternalForms} collapsed={isSidebarCollapsed}>
                      <Icon name="link" className={`${!isSidebarCollapsed && 'mr-2'}`} style={{ fontSize: '12px', opacity: 0.9 }} /> {!isSidebarCollapsed && 'Link External'}
                    </SubLink>
                  </Tooltip>
                </SubMenuItem>
              </SubMenu>
            )}
          </MenuItem>

          {businessCategory?.features?.googleReserveAllowed && (
            <MenuItem collapsed={isSidebarCollapsed}>
              <Tooltip title={isSidebarCollapsed ? 'Reserve With Google' : ''} placement="right">
                <StyledLink
                  to={`#`}
                  onClick={(e) => {
                    e.preventDefault(); // stops the hash jump / navigation
                    handleMenuClose();
                    guardNavigation(() => {
                      history.push(`/admin/reserve-with-google/${businessId}`);
                    });
                  }}
                  active={isActiveManageReserveWithGoogle} collapsed={isSidebarCollapsed}>
                  <div className="icon-wrap"><Icon name='google' /></div>
                  {!isSidebarCollapsed && 'Reserve With Google'}
                </StyledLink>
              </Tooltip>
            </MenuItem>
          )}

          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Subscription' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/pricing/${businessId}`);
                  });
                }}
                active={ispricing} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='credit-card' /></div>
                {!isSidebarCollapsed && 'Subscription'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Payment Setup' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/payment/${businessId}`);
                  });
                }}
                active={isStripeAccount} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='money' /></div>
                {!isSidebarCollapsed && 'Payment Setup'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Console' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/manage-console/${businessId}`);
                  });
                }}
                active={isActiveManageConsole} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='picture-o' /></div>
                {!isSidebarCollapsed && 'Console'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          {!isAssociate && (
            <MenuItem collapsed={isSidebarCollapsed}>
              <Tooltip title={isSidebarCollapsed ? 'Users' : ''} placement="right">
                <StyledLink
                  to={`#`}
                  onClick={(e) => {
                    e.preventDefault(); // stops the hash jump / navigation
                    handleMenuClose();
                    guardNavigation(() => {
                      history.push(`/admin/manage-users/${businessId}`);
                    });
                  }}
                  active={isActiveUsers} collapsed={isSidebarCollapsed}>
                  <div className="icon-wrap"><Icon name='users' /></div>
                  {!isSidebarCollapsed && 'Users'}
                </StyledLink>
              </Tooltip>
            </MenuItem>
          )}

          {/* Last section */}
          <MenuItem className='is-hidden-desktop' style={{ marginTop: '20px', borderTop: '1px solid var(--menu-border)', paddingTop: '10px' }} collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Super Admin' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/superadmin/home`);
                  });
                }}
                active={false} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='user' /></div>
                {!isSidebarCollapsed && 'Super Admin'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          <MenuItem className='is-hidden-desktop' collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Account Settings' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    history.push(`/admin/account/setting`);
                  });
                }}
                active={false} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='gear' /></div>
                {!isSidebarCollapsed && 'Account Settings'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

          <MenuItem collapsed={isSidebarCollapsed}>
            <Tooltip title={isSidebarCollapsed ? 'Logout' : ''} placement="right">
              <StyledLink
                to={`#`}
                onClick={(e) => {
                  e.preventDefault(); // stops the hash jump / navigation
                  handleMenuClose();
                  guardNavigation(() => {
                    handleLogout();
                  });
                }}
                active={false} collapsed={isSidebarCollapsed}>
                <div className="icon-wrap"><Icon name='power-off' /></div>
                {!isSidebarCollapsed && 'Logout'}
              </StyledLink>
            </Tooltip>
          </MenuItem>

        </MenuGroup>
      </ScrollArea>
    </MenuContainer >
  );
};
